export const isStartPlan = (plan: string | null | undefined): boolean =>
  Boolean(plan?.toLowerCase().includes('start'))
